<template>
	<div>
		<div class="font-size-select" :class="{ [`font-size-select-${id}`]: true }">
			<InputSelect :selectedOption.sync="fontSizeModel" :options="sizeList" :disabled="disabled" />
		</div>
	</div>
</template>

<script>
import { v4 as uuid } from 'uuid';
import InputSelect from '../../common/InputSelect';

export default {
	name: 'FontSizeSelect',
	components: {
		InputSelect,
	},
	props: {
		fontSize: { type: Number },
		disabled: { type: Boolean },
	},
	computed: {
		fontSizeModel: {
			set(value) {
				this.$emit('update:fontSize', value);
			},
			get() {
				return this.fontSize;
			},
		},
	},
	data() {
		return {
			id: uuid(),
			sizeList: Array.from(new Array(8), (x, i) => ({ label: `${i + 11}`, value: i + 11 })),
		};
	},
};
</script>
<style scoped lang="scss">
.font-size-select {
	$height: 36px;

	width: 40px;
	border: 0;
	font-size: 12px;

	::v-deep .v-select {
		height: $height;

		.vs__dropdown-toggle {
			height: $height;
		}

		.vs__selected-options {
			flex-grow: unset; // to center the selection
			align-items: center;
			justify-content: center;
		}
		li.vs__dropdown-option {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.vs__search {
			display: none;
		}

		.vs__selected {
			display: inline-block;
		}
		ul {
			height: 200px;
		}
		li {
			padding: 8px 4px !important;
		}
		.vs__actions {
			display: none;
		}
	}
}
</style>
